// Pure decision for what the /login view should do on mount.
// Returns one of: "bridge" | "form" | "home" | "stay".
// - bridge: silently complete the client-login interaction (SSO auto-login)
// - form:   render the login form (require credentials)
// - home:   redirect to the console home (already logged in, no interaction)
// - stay:   render the login form (direct, logged-out console visit)
export function decideLoginAction({ hasUid, prompt, hasToken }) {
  if (hasUid) {
    if (prompt === "login") return "form"; // forced re-auth for the client login
    return hasToken ? "bridge" : "form";
  }
  return hasToken ? "home" : "stay";
}
